// Define the dropdown options
export const entityTypeOptions = [
  "Artist or Athlete",
  "Business/Organization",
  "Central Bank of Issue",
  "Complex Trust",
  "Corporation",
  // "S-Corporation",
  // "P-Corporation",
  "Disclosing Qualified Intermediary",
  "Disregarded Entity",
  "Entity/Disregarded Entity (Single Member LLC)",
  "Estate",
  "Expatriate",
  "Foreign Central Bank of Issue",
  "Foreign Government",
  "Foreign Government - Controlled Entity",
  "Foreign Government - Integral Part",
  "Foreign Private Foundation",
  "Foreign Tax-Exempt Organization",
  "Government",
  "Government of a U.S. Possession",
  "Government or International Organization",
  "Grantor Trust",
  "Hybrid entity making Treaty Claim",
  "Individual",
  "Individual/Sole Proprietor",
  "Individual/Disregarded Entity (Grantor Trust)",
  "International Organization",
  "Individual/Disregarded Entity (Single Member LLC)",
  "Limited Liability Company (Corporation)",
  "Limited Liability Company (Disregarded Entity)",
  "Limited Liability Company (Partnership)",
  "Limited Liability Company (Single-member)",
  "Limited Liability Company (Unknown)",
  "Multiple Types Stated",
  "Non Qualified Intermediary",
  "None",
  "Non-withholding Foreign Grantor Trust",
  "Non-withholding Foreign Partnership",
  "Non-withholding Foreign Simple Trust",
  "Not Listed/Not Stated",
  "Other",
  "Partnership",
  "Partnership other than Withholding Foreign Partnership",
  "Pension",
  "Private Foundation",
  "Qualified Intermediary",
  "Qualified Securities Lender - Other",
  "Qualified Securities Lender - Qualified Intermediary",
  "Simple Trust",
  "Sole Proprietor",
  "Tax-Exempt Organization",
  "Territory FI - not treated as U.S. Person",
  "Territory FI - treated as U.S. Person",
  "Territory Financial Institution",
  "Trust other than Withholding Foreign Trust",
  "Trust/Estate",
  "U.S. Branch",
  "U.S. branch - ECI presumption applied",
  "U.S. branch - not treated as U.S. Person",
  "U.S. Withholding Agent - FI",
  "U.S. Withholding Agent - Other",
  "Unknown Recipient",
  "Withholding Agent",
  "Withholding Foreign Partnership",
  "Withholding Foreign Trust",
  "Withholding qualified holder under section 1445",
  "Government of a U.S. territory",
];

export const entityClassificationOptions = [
  "Not determined",
  "Non-US Financial Institution (FFI)",
  "Not a Financial Institution",
  "Financial Institution (unknown origin)",
  "Affiliated to a US Financial Institution",
  "Affiliated to a Non-US Financial Institution",
  "US Financial Institution",
];

export const chapter4StatusOptions = [
  "501(c) organization",
  "Account Holder of Excluded Financial Account",
  "Active NFFE",
  "Account that is not financial account",
  "Certified Deemed Compliant Non-Reporting FFI",
  "Certified Deemed-Compliant FFI - Other",
  "Certified Deemed-Compliant FFI - Sponsored Entity",
  "Certified deemed-compliant FFI with only low-value accounts",
  "Certified deemed-compliant investment advisors and investment managers",
  "Certified deemed-compliant limited life dept investment entity",
  "Certified deemed-compliant nonregistering local bank",
  "Certified deemed-compliant sponsored, closely held investment vehicle",
  "Deemed Compliant FFI",
  "Direct reporting NFFE",
  "Entity wholly owned by exempt beneficial owners",
  "Excepted Active NFFE",
  "Excepted inter-affiliate FFI",
  "Excepted NFFE",
  "Excepted nonfinancial entity in liquidation or bankruptcy",
  "Excepted nonfinancial group entity",
  "Excepted nonfinancial start-up company",
  "Excepted territory NFFE",
  "Exempt Beneficial Owner",
  "Exempt retirement plans",
  "Financial Institution",
  "Financial Institution Resident in US",
  "Foreign central bank of issue",
  "Foreign government, government of a U.S. possession, or foreign central bank of issue",
  "Foreign government (including a political subdivision), government of a U.S. territory, or foreign central bank of issue",
  "Individual",
  "International organization",
  "Irish Financial Institution or a Partner Jurisdiction Financial Institution",
  "Limited Branch",
  "Limited Branch treated as Nonparticipating FFI",
  "Limited FFI treated as Nonparticipating FFI",
  "Local Client Base Financial Institution",
  "NFFE subject to 1472 withholding",
  "Non-consenting U.S. account",
  "None",
  "Nonfinancial group entity",
  "Nonparticipating FFI",
  "Nonprofit organization",
  "Nonreporting IGA FFI",
  "Other",
  "Owner documented FFI",
  "Participating FFI",
  "Participating FFI - Other",
  "Participating FFI - Reporting Model 2 FFI",
  "Passive NFFE",
  "Passive NFFE identifying Substantial U.S. Owners",
  "Passive NFFE reported by FFI",
  "Passive NFFE with no Substantial U.S. Owners",
  "Publicly traded NFFE or NFFE affiliate of a publicly traded corporation",
  "Recalcitrant Account Holder",
  "Registered deemed-compliant FFI",
  "Registered Deemed-Compliant FFI - Other",
  "Registered Deemed-Compliant FFI - Reporting Model 1 FFI",
  "Registered Deemed-Compliant FFI - Sponsored Entity",
  "Reporting Model 1 FFI",
  "Reporting Model 2 FFI",
  "Restricted distributor",
  "Sponsored Closely Held Investment Vehicle",
  "Sponsored direct reporting NFFE",
  "Sponsored FFI",
  "Sponsored FFI that has not obtained a GIIN",
  "Sponsored Investment Entity Sponsored FFI",
  "Territory FI - not treated as U.S. person",
  "Territory FI - treated as U.S. person",
  "Territory financial institution",
  "Trustee Documented Trust",
  "U.S. Branch",
  "U.S. reportable account",
  "U.S. Withholding Agent - FI",
  "U.S. Withholding Agent - Other",
  "UK Financial Institution or a Partner Jurisdiction Financial Institution",
  "Undocumented Preexisting Obligation",
  "Unknown Recipient",
  "US Financial Institution",
];

export const allSheetNames = [
  "Business Entities",
  "Additional Addresses",
  "Tax Jurisdictions",
  "Accounts",
  "Income Codes",
  "Account Connections",
  "Account Balances",
  "Payment",
  // 'Forms',
  "Audit",
  "View Forms",
  // 'Version',
  // 'Lists',
];

export const listArray = [
  "Taxpayer Type",
  "Country",
  "Entity type",
  "Capacity",
  "Currency",
  "DocumentaryEvidenceType",
  "BalanceEntitytypes",
  "FatcaReportingBalance",
  "UKCDOTStatus",
  "Form Types",
  "Form Status",
  "Chapter 4 Status",
  "Income codes",
  "1099 Income Type",
  "State",
  "Income Type Default",
  "Income Code",
  "CRS Statuses",
  "Chapter4Status",
  "Recipient Code",
  "Risk Status",
  "Exemption Code",
  "Entity Classification",
  "LegalStatus",
  "Trinary",
  "EntityActivationStatus",
  "AddressType",
  "HybridStatus",
  "Boolean",
  "Year",
  "AllocationMethodology",
];

export const businessList = [
  { field: "UniqueIdentifier", header: "Unique Identifier" },
  { field: "Entity Type", header: "Entity Type" },
  { field: "Entity Classification", header: "Entity Classification" },
  { field: "Chapter4Status", header: "Chapter 4 Status" },
  { field: "Legal Status", header: "Legal Status" },
  { field: "Status", header: "Status" },
  { field: "UK CDOT Status", header: "UK CDOT Status" },
  { field: "CRS Status", header: "CRS Status" },
  { field: "BusinessUnit", header: "Business Unit" },
  { field: "FirstName", header: "First Name" },
  { field: "LastName", header: "Last Name" },
  { field: "CountryOfBirth", header: "Country of Birth" },
  { field: "CountryOfBirthOther", header: "Other Country of Birth" },
  { field: "Date of Birth(MM/DD/YYYY)", header: "Date of Birth (MM/DD/YYYY)" },
  {
    field: "Country Of Citizenship For Tax Purposes",
    header: "Country of Citizenship for Tax Purposes",
  },
  {
    field: "Country Of Citizenship For Tax Purposes Other",
    header: "Other Country of Citizenship for Tax Purposes",
  },
  {
    field: "Country Of Citizenship For Tax Purposes2",
    header: "Country of Citizenship for Tax Purposes 2",
  },
  {
    field: "Country Of Citizenship For Tax Purposes3",
    header: "Country of Citizenship for Tax Purposes 3",
  },
  { field: "Business Name", header: "Business Name" },
  { field: "Doing Business As Name", header: "Doing Business As Name" },
  { field: "Previous Name", header: "Previous Name" },
  { field: "Previous Name Date", header: "Previous Name Date" },
  { field: "Date of Incorporation", header: "Date of Incorporation" },
  { field: "Registration Number", header: "Registration Number" },
  { field: "Business Unit Contact Name", header: "Business Unit Contact Name" },
  { field: "Business Country", header: "Business Country" },
  { field: "CountryOther", header: "Other Country" },
  { field: "Domicile Country", header: "Domicile Country" },
  { field: "TaxPayer ID Type", header: "Taxpayer ID Type" },
  { field: "ATIN", header: "ATIN" },
  { field: "EIN", header: "EIN" },
  { field: "ITIN", header: "ITIN" },
  { field: "PTIN", header: "PTIN" },
  { field: "QIEIN", header: "QIEIN" },
  { field: "SSNOrITIN", header: "SSN or ITIN" },
  { field: "WP-EIN", header: "WP-EIN" },
  { field: "WT-EIN", header: "WT-EIN" },
  { field: "GIIN", header: "GIIN" },
  { field: "ForeignTaxpayerCountry", header: "Foreign Taxpayer Country" },
  { field: "ForeignTaxpayerId", header: "Foreign Taxpayer ID" },
  { field: "VAT", header: "VAT" },
  { field: "IsCheckPerformed", header: "Is Check Performed" },
  { field: "IsSuccessful", header: "Is Successful" },
  { field: "TIN Check Date(MM/DD/YYYY)", header: "TIN Check Date(MM/DD/YYYY)" },
  { field: "1042s payment received", header: "1042s Payment Received" },
  { field: "Address Type", header: "Address Type" },
  { field: "Perm. Address Line1", header: "Permanent Address Line 1" },
  { field: "Perm. Address Line2", header: "Permanent Address Line 2" },
  { field: "Perm. Address Line3", header: "Permanent Address Line 3" },
  { field: "City_Town", header: "City/Town" },
  { field: "State_Province", header: "State/Province" },
  { field: "Perm. Country", header: "Permanent Country" },
  { field: "Perm. CountryOther", header: "Other Permanent Country" },
  { field: "Zip_PostalCode", header: "Zip/Postal Code" },
  { field: "Mail Address Type", header: "Mail Address Type" },
  { field: "Mail Address Line1", header: "Mail Address Line 1" },
  { field: "Mail Address Line2", header: "Mail Address Line 2" },
  { field: "Mail Address Line3", header: "Mail Address Line 3" },
  { field: "Mail City_Town", header: "Mail City/Town" },
  { field: "State_Province2", header: "Mail State/Province" },
  { field: "Mail Country", header: "Mail Country" },
  { field: "Mail CountryOther", header: "Other Mail Country" },
  { field: "Mail Zip_PostalCode", header: "Mail Zip/Postal Code" },
  { field: "Contact Name", header: "Contact Name" },
  { field: "Contact Email", header: "Contact Email" },
  { field: "Contact Name2", header: "Contact Name 2" },
  { field: "Contact Email2", header: "Contact Email 2" },
  { field: "Contact Name3", header: "Contact Name 3" },
  { field: "Contact Email3", header: "Contact Email 3" },
  { field: "Contact CellNumber Country", header: "Contact Cell Number Country" },
  { field: "Contact  CellNumber", header: "Contact Cell Number" },
  { field: "Contact Telephone Country", header: "Contact Telephone Country" },
  { field: "Contact  TelephoneNumber", header: "Contact Telephone Number" },
  { field: "Contact Telephone Country2", header: "Contact Telephone Country 2" },
  { field: "Contact  TelephoneNumber2", header: "Contact Telephone Number 2" },
  { field: "HybridStatus", header: "Hybrid Status" },
  { field: "IsUSPerson", header: "Is US Person" },
  { field: "IsUSGreenCardHolder", header: "Is US Green Card Holder" },
  { field: "Is US Person Classification", header: "US Person Classification" },
  { field: "IsDualCitizenshipHolder", header: "Is Dual Citizenship Holder" },
  {
    field: "DoesDualCitizenshipIncludeUnitedStates",
    header: "Does Dual Citizenship Include United States",
  },
  { field: "IsBornOrganisedInUS", header: "Is Born or Organised in US" },
  { field: "HasRenouncedCitizenship", header: "Has Renounced Citizenship" },
  { field: "InUSA31DaysCurrentYear", header: "In USA 31 Days This Year" },
  { field: "DaysInCurrentYear", header: "Days in Current Year" },
  { field: "DaysInPrecedingYear", header: "Days in Preceding Year" },
  { field: "DaysInFurtherPrecedingYear", header: "Days in Further Preceding Year" },
  { field: "DeceasedOn", header: "Deceased On" },
  { field: "Notes", header: "Notes" },
  { field: "AltVendorID1", header: "Alternate Vendor ID 1" },
  { field: "AltVendorID2", header: "Alternate Vendor ID 2" },
  { field: "AltVendorID3", header: "Alternate Vendor ID 3" },
  { field: "Signed Certification Confirmation", header: "Signed Certification Confirmation" },
  {
    field: "Signed Certification Confirmation Date",
    header: "Signed Certification Confirmation Date",
  },
];

export const addressList = [
  "UniqueIdentifier",
  "Address Type",
  "Address Line1",
  "Address Line2",
  "Address Line3",
  "City_Town",
  "State_Province",
  "Country",
  "CountryOther",
  "Zip_PostalCode",
];
// export const accountConnectionsList = ['Parent',
//     'Child',
//     'Allocation',
//     'Capital Committed (Amount $)',
//     'Date MM-DD-YYYY',];

export const accountConnectionsList = [
  { field: "Parent", header: "Parent" },
  { field: "Child", header: "Child" },
  { field: "Allocation", header: "Allocation" },
  { field: "Capital Committed (Amount $)", header: "Capital Committed (Amount $)" },
  { field: "Date MM-DD-YYYY", header: "Date (MM-DD-YYYY)" },
];
export const taxList = ["UniqueIdentifier", "JurisdictionTaxCountry", "TIN", "IsTINAvailable"];
export const accountsList = [
  { field: "Number", header: "Account Number" },
  { field: "Name", header: "Account Name" },
  { field: "Recipient Code", header: "Recipient Code" },
  { field: "OpenedOn", header: "Opened On" },
  { field: "ClosedOn", header: "Closed On" },
  { field: "Risk Status", header: "Risk Status" },
  { field: "IsFlowThroughAccount", header: "Is Flow Through Account" },
  { field: "Assume Primary WHR", header: "Assume Primary WHR" },
  { field: "Aggregate WHR 0%", header: "Aggregate WHR 0%" },
  { field: "EntityUID", header: "Entity UID" },
  { field: "Signatory Entity ID", header: "Signatory Entity ID" },
  { field: "Signatory Capacity", header: "Signatory Capacity" },
  { field: "CapacityOther", header: "Other Capacity" },
  { field: "Bank Name", header: "Bank Name" },
  { field: "Bank Account Number", header: "Bank Account Number" },
  { field: "Sort Code", header: "Sort Code" },
  { field: "SWIFT Code", header: "SWIFT Code" },
  { field: "ABA Number", header: "ABA Number" },
  { field: "Cheque Payment", header: "Cheque Payment" },
  { field: "Remittance Name", header: "Remittance Name" },
  { field: "Remittance Address Line 1", header: "Remittance Address Line 1" },
  { field: "Remittance Address Line2", header: "Remittance Address Line 2" },
  { field: "Remittance City_Town", header: "Remittance City/Town" },
  { field: "Remittance State_Province", header: "Remittance State/Province" },
  { field: "Remittance Country", header: "Remittance Country" },
  { field: "Remittance CountryOther", header: "Other Remittance Country" },
  { field: "Remittance Zip_PostalCode", header: "Remittance Zip/Postal Code" },
  { field: "Allocation Methodology", header: "Allocation Methodology" },
];

export const incomeList = [
  "Number",
  "Income Type",
  "Income Code",
  "Exemption Code",
  "Apply Exemption to All Accounts",
];
export const accountBalancesList = [
  "Entity UID",
  "Entity Type",
  "Account Number",
  "Year",
  "Dormant",
  "FATCA Reporting Balance",
  "This Account Balance",
  "Interest",
  "Dividends",
  "Gross Proceeds",
  "Other",
  "Currency Code",
];
export const paymentList = [
  "Account Number",
  "Invoice Number",
  "SAP ID",
  "Payment Date (mm/dd/yyyy)",
  "1099 Income Type",
  "1042 Income Code",
  "Exemption Code",
  "Percentage of US Income",
  "Gross Amount",
  "Expenses",
];
export const formsList = [
  "UID",
  "First name",
  "Last name",
  "Business name",
  "Form type and revision",
  "Entity Type",
  "FATCA Entity Types",
  "Signature date (mm/dd/yyyy)",
  "Treaty country",
  "Active Status",
  "LOB Code applied",
  "Tax Form Foreign Tax ID",
  "Foreign Tax Country",
  "Tax Identification Type",
  "Tax Identification Number",
  "Self-cert Primary Jurisdiction2",
  "Self-cert Primary Jurisdiction TIN",
  "Self-cert Additional Jurisdiction1",
  "Self-cert Additional Jurisdiction1 TIN",
  "Self-cert Additional Jurisdiction2",
  "Self-cert Additional Jurisdiction2 TIN",
];
export const versionList = ["1.5"];
export const statesList = [
  "Alabama (AL)",
  "Alaska (AK)",
  "Alberta (AB)",
  "Arizona (AZ)",
  "Arkansas (AR)",
  "British Columbia (BC)",
  "California (CA)",
  "Colorado (CO)",
  "Connecticut (CT)",
  "Delaware (DE)",
  "District of Columbia (DC)",
  "Florida (FL)",
  "Georgia (GA)",
  "Hawaii (HI)",
  "Idaho (ID)",
  "Illinois (IL)",
  "Indiana (IN)",
  "Iowa (IA)",
  "Kansas (KS)",
  "Kentucky (KY)",
  "Louisiana (LA)",
  "Maine (ME)",
  "Manitoba (MB)",
  "Maryland (MD)",
  "Massachusetts (MA)",
  "Michigan (MI)",
  "Minnesota (MN)",
  "Mississippi (MS)",
  "Missouri (MO)",
  "Montana (MT)",
  "Nebraska (NE)",
  "Nevada (NV)",
  "New Brunswick (NB)",
  "New Hampshire (NH)",
  "New Jersey (NJ)",
  "New Mexico (NM)",
  "New York (NY)",
  "Newfoundland and Labrador (NF)",
  "North Carolina (NC)",
  "North Dakota (ND)",
  "Northwest Territories (NT)",
  "Nova Scotia (NS)",
  "Nunavut (NU)",
  "Ohio (OH)",
  "Oklahoma (OK)",
  "Ontario (ON)",
  "Oregon (OR)",
  "Pennsylvania (PA)",
  "Prince Edward Island (PE)",
  "Puerto Rico (PR)",
  "Quebec (QC)",
  "Rhode Island (RI)",
  "Saskatchewan (SK)",
  "South Carolina (SC)",
  "South Dakota (SD)",
  "Tennessee (TN)",
  "Texas (TX)",
  "Utah (UT)",
  "Vermont (VT)",
  "Virgin Islands (VI)",
  "Virginia (VA)",
  "Washington (WA)",
  "West Virginia (WV)",
  "Wisconsin (WI)",
  "Wyoming (WY)",
  "Yukon (YT)",
];

export const usLocations = [
  "Alabama (AL)",
  "Alaska (AK)",
  "Arizona (AZ)",
  "Arkansas (AR)",
  "California (CA)",
  "Colorado (CO)",
  "Connecticut (CT)",
  "Delaware (DE)",
  "District of Columbia (DC)",
  "Florida (FL)",
  "Georgia (GA)",
  "Hawaii (HI)",
  "Idaho (ID)",
  "Illinois (IL)",
  "Indiana (IN)",
  "Iowa (IA)",
  "Kansas (KS)",
  "Kentucky (KY)",
  "Louisiana (LA)",
  "Maine (ME)",
  "Maryland (MD)",
  "Massachusetts (MA)",
  "Michigan (MI)",
  "Minnesota (MN)",
  "Mississippi (MS)",
  "Missouri (MO)",
  "Montana (MT)",
  "Nebraska (NE)",
  "Nevada (NV)",
  "New Hampshire (NH)",
  "New Jersey (NJ)",
  "New Mexico (NM)",
  "New York (NY)",
  "North Carolina (NC)",
  "North Dakota (ND)",
  "Ohio (OH)",
  "Oklahoma (OK)",
  "Oregon (OR)",
  "Pennsylvania (PA)",
  "Puerto Rico (PR)",
  "Rhode Island (RI)",
  "South Carolina (SC)",
  "South Dakota (SD)",
  "Tennessee (TN)",
  "Texas (TX)",
  "Utah (UT)",
  "Vermont (VT)",
  "Virgin Islands (VI)",
  "Virginia (VA)",
  "Washington (WA)",
  "West Virginia (WV)",
  "Wisconsin (WI)",
  "Wyoming (WY)",
];

export const canadianLocations = [
  "Alberta (AB)",
  "British Columbia (BC)",
  "Manitoba (MB)",
  "New Brunswick (NB)",
  "Newfoundland and Labrador (NF)",
  "Northwest Territories (NT)",
  "Nova Scotia (NS)",
  "Nunavut (NU)",
  "Ontario (ON)",
  "Prince Edward Island (PE)",
  "Quebec (QC)",
  "Saskatchewan (SK)",
  "Yukon (YT)",
];
export const LegalStatus = [
  "Corporation",
  "Foundation",
  "General Partnership",
  "Limited Liability Company",
  "Limited Partnership",
  "Private Limited Company",
  "Public Limited Company",
  "Sole Trader",
  "Trust",
  "Unknown",
];
export const RecipientCode = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
];

export const auditColumnNames = [
  { field: "dataType", header: "Data Type" },
  { field: "action", header: "Action" },
  { field: "uid", header: "Unique Identifier" },
  { field: "fieldName", header: "Field Name" },
  { field: "oldValue", header: "Old Value" },
  { field: "newValue", header: "New Value" },
  { field: "userName", header: "User Name" },
  { field: "modifiedDate", header: "Modified Date" },
];
export const extractedColumnNames = [
  { field: "Name", header: "Name" },
  { field: "Number", header: "Number" },
  { field: "Entity Type", header: "Entity Type" },
  { field: "Entity Classification", header: "Entity Classification" },
  { field: "Chapter4Status", header: "Chapter 4 Status" },
  { field: "EIN", header: "EIN" },
  { field: "SSNOrITIN", header: "SSN or ITIN" },
  { field: "GIIN", header: "GIIN" },
  { field: "ForeignTaxpayerId", header: "Foreign Taxpayer ID" },
  { field: "Perm. Country", header: "Permanent Country" },
  { field: "Perm. Address Line1", header: "Permanent Address Line 1" },
  { field: "Allocation", header: "Allocation" },
];
//Global Intermediary Identification Number (GIIN)
//Employer Identification Number (EIN)
